import { useState, useEffect } from 'react';
// import useMarketFilterApi, { MarketSpecailType } from '@/pages/intelligence/hooks/useMarketSelector';
import useMarketFilterApi from '@/pages/intelligence/hooks/useMarketSelector';
import { fetchGenresAndHeadQuaters } from '../services';
// import { handleRegionsCountriesData2Standard } from '../utils';

export default function useFilterOptions() {
  const [isFilterOptionsInited, setIsFilterOptionsInited] = useState(false);
  const [loading, setLoading] = useState(true);

  // const { regionOptions } = useMarketFilterApi({
  //   filterType: MarketSpecailType.TopCompanies,
  //   formatter: (data: any) => handleRegionsCountriesData2Standard(data?.data?.region_country),
  // });

  const { regionOptions } = useMarketFilterApi({});

  const [headQuatersOptionsData, setHeadQuatersOptionsData] = useState<any[]>([]);
  const getData = async () => {
    try {

      setLoading(true)
      const { country } = await fetchGenresAndHeadQuaters();
      const countries = country?.map((item: any) => ({
        value: item?.country_name_en || '',
        textEN: item?.country_name_en || '',
        textCN: item?.country_name_cn || '',
        icon: item?.country_name_abbre || '',
      })) || [];
      setHeadQuatersOptionsData(countries);
      setIsFilterOptionsInited(true);
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return {
    loading,
    isFilterOptionsInited,
    regionOptions,
    headQuatersOptionsData,
  };
}
